import { gql } from 'graphql-request'

export const USUARIO_BY_EMAIL_QUERY = gql`
  query UsuarioByEmailQuery($email: String!) {
    usuarioByEmail(email: $email) {
      id
      nome
      email
    }
  }
`
